import * as React from 'react'
import clsx from 'clsx'
import { Button, Search, Space, Col } from 'components/common'

export interface LedgerItemsSearchProps {
  searchResult?: string
  warningMessage?: string
  onSearch?: () => void
  setSearchResult?: (params: string) => void
  searchClear?: () => void
}

export const LedgerItemsSearch = ({
  warningMessage,
  onSearch,
  searchClear,
  searchResult,
  setSearchResult,
}: LedgerItemsSearchProps): JSX.Element => {
  return (
    <div style={{ marginBottom: 10 }}>
      {warningMessage && (
        <div className="ml-2 text-red-600">{warningMessage}</div>
      )}
      <Col span={24} className={clsx('flex', 'flex-end', 'justify-end')}>
        <Space direction="horizontal">
          <Search
            autoComplete="off"
            placeholder="項目のタイトル"
            value={searchResult}
            onChange={(e) => setSearchResult(e.target.value)}
            onPressEnter={() => onSearch()}
          />

          <Button onClick={onSearch}>絞り込む</Button>
          <Button onClick={searchClear}>クリア</Button>
        </Space>
      </Col>
    </div>
  )
}
